import { intersection } from 'lodash'
import ComponentLoader from './component-loader'
import { 
  ShortCode, 
  Jitsi, 
  ControlledContent, 
  Ranking, 
  AmazonRedim,
  VimeoPlayerEvaluable,
  Dialog,
  Survey,
  SurveyQuestion,
  SurveyAnswers,
  SurveyAnswer,
  Forms
} from "basecomps"

const blockcomponents = {
  'playmotiv-shortcode': ShortCode,
  'playmotiv-shortcode-jitsi': Jitsi,
  'wp-block-playmotivcloud-controlledcontent': ControlledContent,
  'wp-block-playmotivcloud-ranking': Ranking,
  'wp-block-playmotivcloud-amazonredim': AmazonRedim,
  'wp-block-playmotivcloud-vimeoplayerevaluable': VimeoPlayerEvaluable,
  'wp-block-playmotivcloud-slide': {
    path: 'playmotiv-cloud-core-v4/content/slide'
  },
  'wp-block-playmotivcloud-vimeoplayer': {
    path: 'playmotiv-cloud-core-v4/media/vimeoplayer'
  },
  'wp-block-playmotivcloud-reading-dialog': Dialog,
  'wp-block-playmotivcloud-survey': Survey,
  'wp-block-playmotivcloud-surveyquestion': SurveyQuestion,
  'wp-block-playmotivcloud-surveyanswers': SurveyAnswers,
  'wp-block-playmotivcloud-surveyanswer': SurveyAnswer,
  'wp-block-playmotivcloud-forms': Forms
}

const replace = (domNode) => {  

    // detect by classname & blockcomponents table

    const blockcomponentkeys = Object.keys(blockcomponents)    
    const classes = domNode.attribs?.class?.split(' ') 
    const replacecomponent = intersection(blockcomponentkeys, classes)

    if (replacecomponent.length) {

        const Component = blockcomponents[replacecomponent[0]]

        if (Component.path) { 

          return <ComponentLoader 
            component={Component.path}
            replace={replace}
            { ...domNode } 
          />

        } else {

          return <Component {...domNode} replace={replace} />
        }
    }

    if (domNode.attribs && domNode.attribs['data-component']) {

      const componentpath = domNode.attribs['data-component']

      return <ComponentLoader 
        component={componentpath}
        replace={replace}
        { ...domNode } 
      />
    }

    return domNode
}

export default replace
